import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { API_URL } from "constants/ApiConstant";
import { get } from "services/ApiService"; // Assuming you are making API calls via this service
import { useLocation } from "react-router-dom";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [dataNotification, setDataNotification] = useState(null);
  const location = useLocation(); // Track location changes

  const getNotification = useCallback(async () => {
    const storedNotification = localStorage.getItem(AUTH_TOKEN);
    if (!storedNotification) {
      return null;
    }

    try {
      const res = await get(API_URL.notification + "/datatable");
      const resCounter = await get(API_URL.notification + "/unread-counter");
      const resUnpaid = await get(
        API_URL.dashboard + "/total-unpaid-cash-invoice",
      );
      if (res?.status === 200) {
        const nextNotification = {
          list: res.data.data,
          counter: resCounter?.data?.data?.unread || 0,
          unpaid: resUnpaid?.data?.data || 0,
        };

        setDataNotification(nextNotification);
        return nextNotification;
      }
    } catch (error) {
      console.error("Error fetching notification:", error);
    }
    return null;
  }, []);

  const checkSession = () => {
    getNotification();
  };

  useEffect(() => {
    // This will trigger on every location change
    checkSession();
  }, [location, getNotification]); // Dependency array includes 'location' to track changes

  const notificationContextValue = useMemo(
    () => ({
      list: dataNotification?.list,
      counter: dataNotification?.counter || 0,
      unpaid: dataNotification?.unpaid || 0,
      refreshNotifications: getNotification,
    }),
    [dataNotification, getNotification],
  );

  return (
    <NotificationContext.Provider value={notificationContextValue}>
      {children}
    </NotificationContext.Provider>
  );
};

// Hook to use profile context
export const useGetNotification = () => {
  return useContext(NotificationContext);
};
